export default "__VITE_ASSET___1ZV4ErK__"